import type { TrackingProperties } from '@change-corgi/tracking-properties';

import type { ShareAction } from '#src/app/shared/hooks/share';

import type { PetitionShareChannel } from '../../usePetitionShare';

const CHANNEL_MAP: Partial<Record<PetitionShareChannel, string>> = {
	facebookMessenger: 'facebook_message',
	copy: 'copylink',
};

export function shareActionsToEventProps(actions: readonly ShareAction[]): TrackingProperties {
	const channels: readonly string[] = actions.map(({ channel }) => CHANNEL_MAP[channel] || channel);
	return {
		available_contexts: channels,
		show_copylink: channels.includes('copylink'),
		show_email: channels.includes('email'),
		show_embed: false,
		show_facebook: channels.includes('facebook'),
		show_facebook_message: channels.includes('facebook_message'),
		show_line: channels.includes('line'),
		show_sms: channels.includes('sms'),
		show_twitter: channels.includes('twitter'),
		show_vk: channels.includes('vk'),
		show_whatsapp: channels.includes('whatsapp'),
	};
}
